import Axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../context/AuthContext'
import Conversation from '../conversation/Conversation'

import './conversations.css'

const Conversations = ({conversations}) => {
  return (
    <>
      <div className="conversationsWrapper">
        {conversations.map((conversation) => <Conversation key={conversation._id} conversation={conversation} /> )}
      </div>
    </>
  )
}

export default Conversations